import { gql } from '@apollo/client'

export const GET_PROJECT_PHASES = gql`
  query fetchProjectPhasesForProjectJourney($projectSlug: String!) {
    project(slug: $projectSlug) {
      id
      slug
      projectUuid
      name
      primaryFlowPhases {
        id
        status
        updatedAt
        phaseName
        phaseSlugEnum
        departmentSlugEnum
        releaseWindows {
          start
        }
      }
    }
  }
`

export const GET_PROJECT = gql`
  query fetchProjectForProjectJourney($projectUuid: String!) {
    guildUpdates(input: { projectId: $projectUuid }) {
      id
    }
  }
`
